import PurchaseBusinessService from '../../purchase-business-service.js';
import previewEngineeringContract from '../preview-engineering-contract/index.vue';
import previewServiceContract from '../preview-service-contract/index.vue';
const debounce = require('lodash.debounce');
import { validateDate } from '@/utils/common.js';

export default {
  components: {
    previewEngineeringContract,
    previewServiceContract
  },
  data() {
    const validateStartTime = (rule, value, callback) => {
      if(!value) {
        callback(new Error('请选择开始日期'));
      } else if(validateDate(value, this.form.commencementDate)) {
        callback(new Error('结束日期不能早于开始日期'));
      } else {
        callback();
      }
    };
    const validateEndTime = (rule, value, callback) => {
      if(!value) {
        callback(new Error('请选择结束日期'));
      } else if(validateDate(this.form.completionDate, value)) {
        callback(new Error('结束日期不能早于开始日期'));
      } else {
        callback();
      }
    };
    const validateLiquidatedDamages = (rule, value, callback) => {
      if (value === '' || value === null) {
        return callback(new Error('请输入违约金'));
      } else if (value > 9999999 || value < 0 || (value.toString().indexOf('.') !== -1)) {
        return callback(new Error('只能输入0~9999999的整数'));
      } else {
        callback();
      }
    };
    const validateSecondsLiquidatedDamages = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入乙方违约金'));
      } else if (value > 1000 || value < 1 || (value.toString().indexOf('.') !== -1)) {
        return callback(new Error('只能输入1~1000的整数'));
      } else {
        callback();
      }
    };
    const validateDelayLiquidatedDamages = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入拖延违约金'));
      } else if (value > 1000 || value < 1 || (value.toString().indexOf('.') !== -1)) {
        return callback(new Error('只能输入1~1000的整数'));
      } else {
        callback();
      }
    };
    return {
      centerDialogVisible: false,
      projectType: '',
      id: '',
      otherAgreementsDefText: '1.施工中发生的各种质量及安全事故均由乙方承担全部责任。\n2.甲方负责代扣代缴工程涉及的所有税费，负责办理施工验收手续，并承担相应责任。',
      form: {
        commencementDate: '',
        completionDate: '',
        otherAgreements: ''
      },
      preview: {},
      fundsInfo: {},
      rules: {
        purchaseScope: [
          { required: true, message: '请输入项目内容及范围', trigger: 'blur' }
        ],
        // commencementDate: [
        //   { required: true, message: '请输入开工日期', trigger: 'blur' }
        // ],
        // completionDate: [
        //   { required: true, message: '请输入竣工日期', trigger: 'blur' }
        // ],
        commencementDate: [
          { required: true, validator: validateStartTime, trigger: 'blur' }
        ],
        completionDate: [
          { required: true, validator: validateEndTime, trigger: 'blur' }
        ],
        qualityStandard: [
          { required: true, message: '请输入质量标准', trigger: 'blur' }
        ],
        contractPaymentMethod: [
          { required: true, message: '请输入合同价款支付方式', trigger: 'blur' }
        ],
        performanceAmount: [
          { required: true, message: '请输入履约保证金', trigger: 'blur' }
        ],
        performanceBondPaymentMethod: [
          { required: true, message: '请输入履约保证金支付方式', trigger: 'blur' }
        ],
        // workerPaymentMethod: [
        //   { required: true, message: '请输入农民工工资保证金支付方式', trigger: 'blur' }
        // ],
        engineeringAmount: [
          { required: true, message: '请输入工程质保金', trigger: 'blur' }
        ],
        engineeringWarrantyPaymentMethod: [
          { required: true, message: '请输入工程质保金支付方式', trigger: 'blur' }
        ],
        liquidatedDamages: [
          { required: true, validator: validateLiquidatedDamages, trigger: 'blur' }
        ],
        secondsLiquidatedDamages: [
          { required: true, validator: validateSecondsLiquidatedDamages, trigger: 'blur' }
        ],
        delayLiquidatedDamages: [
          { required: true, validator: validateDelayLiquidatedDamages, trigger: 'blur' }
        ],
        contractCount: [
          { required: true, message: '请输入合同份数', trigger: 'blur' }
        ]
      },
      purchaseFileType: [],
      constructionPeriod: 0,
      pickerOptionsOne: {
        disabledDate(time) {
          return time.getTime() <= (Date.now()-(24 * 60 * 60 * 1000));
        }
      },
      pickerOptionsTwo: {
        disabledDate: (time) => {
          return time.getTime() <= (new Date(this.form.commencementDate).getTime());
        }
      }
    };
  },
  created() {
    this.projectType = this.$route.query.projectType;
    this.id = this.$route.query.id;
    PurchaseBusinessService.getContractDetail(this.id).then(res => {
      if(res.code === '0'){
        this.form = res.data;
        this.form.otherAgreements = res?.data?.otherAgreements || this.otherAgreementsDefText;
      }
    });
    this.getContractDetailP();
  },
  computed: {
    commencementDate() {
      if(this.form.commencementDate){
        return this.form.commencementDate;
      }
    },
    completionDate() {
      if(this.form.completionDate){
        return this.form.completionDate;
      }
    }
    // liquidatedDamages() {
    //   if(this.form.liquidatedDamages === 0){
    //     return this.form.liquidatedDamages;
    //   }
    // },
    // secondsLiquidatedDamages() {
    //   if(this.form.secondsLiquidatedDamages === 0){
    //     return this.form.secondsLiquidatedDamages;
    //   }
    // },
    // delayLiquidatedDamages() {
    //   if(this.form.delayLiquidatedDamages === 0){
    //     return this.form.delayLiquidatedDamages;
    //   }
    // }
  },
  watch: {
    commencementDate: function () {
      if(this.form.commencementDate && this.form.completionDate){
        this.form.constructionPeriod = (new Date(this.form.completionDate).getTime() - new Date(this.form.commencementDate).getTime())/(1000*60*60*24) + 1;
      }else{
        this.form.constructionPeriod = 0;
      }
    },
    completionDate: function () {
      if(this.form.commencementDate && this.form.completionDate){
        // console.log('111', new Date(this.form.commencementDate).getTime(), new Date(this.form.completionDate).getTime());
        this.form.constructionPeriod = (new Date(this.form.completionDate).getTime() - new Date(this.form.commencementDate).getTime())/(1000*60*60*24) + 1;
      }else{
        this.form.constructionPeriod = 0;
      }
    }
    // liquidatedDamages: function (){
    //   if(this.form.liquidatedDamages === 0){
    //     this.form.liquidatedDamages = null;
    //   }
    // },
    // secondsLiquidatedDamages: function (){
    //   if(this.form.secondsLiquidatedDamages === 0){
    //     this.form.secondsLiquidatedDamages = null;
    //   }
    // },
    // delayLiquidatedDamages: function (){
    //   if(this.form.delayLiquidatedDamages === 0){
    //     this.form.delayLiquidatedDamages = null;
    //   }
    // }
  },
  methods: {
    previousStep () {
      this.$router.back();
    },
    getContractDetailP (isShow) {
      PurchaseBusinessService.getContractDetailP(this.id).then(res => {
        if(res.code === '0'){
          this.preview = res.data;

          this.fundsInfo = JSON.parse(res.data.fundsInfo);
          if (isShow) {
            this.centerDialogVisible= true;
          }
        }
      });
    },
    submit: debounce(function(){
      this.$refs['attachmentForm'].validate(valid => {
        if (valid) {
          this.$confirm('确定要提交合同？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.saveContract(false);
          }).catch(() => {});
        } else {
          return false;
        }
      });
    }, 2000, {
      'leading': true,
      'trailing': false
    }),
    saveContract: debounce(function(prepareCommitType){
      PurchaseBusinessService.getContractDetailPost({...this.form, prepareCommitType: prepareCommitType}).then(res => {
        console.log(res);
        if(res.code === '0'){
          if (prepareCommitType) {
            this.getContractDetailP(true);
            return;
          }
          this.$message({
            message: '提交成功',
            type: 'success',
            duration: 1000,
            offset: 327
          });
          this.$router.back();
        }else{
          this.$message({
            message: res.reason,
            type: 'error',
            duration: 1000,
            offset: 327
          });
        }
      });
    }, 2000, {
      'leading': true,
      'trailing': false
    })
  }
};
